// Auto-generated from the authoritative FairFix logo pack (potrace vector trace).
// Do not hand-edit path data. Colors are applied by the Brand component per variant.
export const LOGO_VIEWBOX = "0 0 1089.000000 1095.000000";
export const LOGO_TRANSFORM = "translate(0.000000,1095.000000) scale(0.100000,-0.100000)";
export const LOGO_PURPLE_D = `M5340 10695 c0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7
-15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15
-30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15
-30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30
-15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10
-10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15
-15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0
-30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30
-15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7
-15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30
-5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15
-8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30
-5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15
-8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30
-15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10
-10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30
-15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -13 0
-15 -425 -15 -3765 0 -3340 2 -3765 15 -3765 8 0 15 7 15 15 0 10 10 15 30 15
20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30
15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15
30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 7
15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7
15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0
15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0
8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15
8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30
15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15
15 15 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30
5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10
15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20
0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 7 15 15 0
10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30
15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7 15 15 15 13 0 15 143
15 1230 l0 1230 30 0 c20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10
15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15
20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30
15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10
10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15
8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5
30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8
7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15
20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5
30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10
10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15
8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5
30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10
10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30
15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7
15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0
10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30
15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0
30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0
10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15
30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0
15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30
15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7
15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15
20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 13 0 15 110
15 930 l0 930 -45 0 c-33 0 -45 -4 -45 -15 0 -10 -10 -15 -30 -15 -20 0 -30
-5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15
-30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7
-15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15
-30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7
-15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15
-30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7
-15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15
-30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0
-10 -10 -15 -30 -15 l-30 0 0 510 0 510 30 0 c20 0 30 5 30 15 0 10 10 15 30
15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7
15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0
10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15
15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30
5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0
10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30
15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0
30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0
10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15
30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0
15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30
15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10
10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15
20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5
30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10
10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30
15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0
30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0
10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15
30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0
30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30
15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10
15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15
20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5
30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10
10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30
15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0
30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7 15 15 15 13 0 15 33 15 240 0
207 2 240 15 240 12 0 15 18 15 105 0 87 -3 105 -15 105 -13 0 -15 47 -15 360
0 313 2 360 15 360 12 0 15 17 15 90 0 73 -3 90 -15 90 -13 0 -15 23 -15 150
0 127 -2 150 -15 150 -8 0 -15 -7 -15 -15z M4770 1905 c0 -8 -7 -15 -15 -15 -13 0 -15 -42 -15 -315 0 -273 2
-315 15 -315 8 0 15 -7 15 -15 0 -13 42 -15 315 -15 273 0 315 2 315 15 0 8 7
15 15 15 13 0 15 42 15 315 0 273 -2 315 -15 315 -8 0 -15 7 -15 15 0 13 -42
15 -315 15 -273 0 -315 -2 -315 -15z M5640 1905 c0 -8 -7 -15 -15 -15 -13 0 -15 -42 -15 -315 0 -273 2
-315 15 -315 8 0 15 -7 15 -15 0 -13 42 -15 315 -15 273 0 315 2 315 15 0 8 7
15 15 15 13 0 15 43 15 330 l0 330 -330 0 c-287 0 -330 -2 -330 -15z M4770 1035 c0 -8 -7 -15 -15 -15 -13 0 -15 -40 -15 -300 0 -260 2
-300 15 -300 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 -7 15 -15 0 -12 20 -15 120
-15 100 0 120 3 120 15 0 13 23 15 150 15 l150 0 0 315 c0 273 -2 315 -15 315
-8 0 -15 7 -15 15 0 13 -42 15 -315 15 -273 0 -315 -2 -315 -15z M5640 1035 c0 -8 -7 -15 -15 -15 -13 0 -15 -42 -15 -315 l0 -315 30
0 c20 0 30 -5 30 -15 0 -13 23 -15 150 -15 127 0 150 2 150 15 0 8 7 15 15 15
8 0 15 -7 15 -15 0 -12 20 -15 120 -15 100 0 120 3 120 15 0 10 10 15 30 15
l30 0 0 315 c0 273 -2 315 -15 315 -8 0 -15 7 -15 15 0 13 -42 15 -315 15
-273 0 -315 -2 -315 -15z`;
export const LOGO_GREY_D = `M5640 10650 c0 -47 3 -60 15 -60 13 0 15 -105 15 -885 0 -780 2 -885
15 -885 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15
30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15
30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15
30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 13 0 15 110 15 930 0 820 -2 930 -15 930 -8 0 -15 7 -15 15 0 8 -7 15 -15
15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30
15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30
15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15
-20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15
l-30 0 0 -60z M5850 5895 c0 -1527 2 -1725 15 -1725 8 0 15 -7 15 -15 0 -10 10 -15
30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15
20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20
0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -8 7 -15 15 -15 8 0 15
-7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7
15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15
-15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0
-10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0
-10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0
-10 10 -15 30 -15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 -7 15 -15 0 -8 -7
-15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -8 7 -15
15 -15 8 0 15 -7 15 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -8 7 -15 15 -15
13 0 15 105 15 885 l0 885 30 0 c20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0
30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0
30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15
-7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30
-5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5
30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5
30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30
-15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 5 30
15 0 8 -7 15 -15 15 -13 0 -15 30 -15 210 0 180 2 210 15 210 12 0 15 13 15
60 0 47 -3 60 -15 60 -13 0 -15 78 -15 645 l0 645 -30 0 c-20 0 -30 5 -30 15
0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15
0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0
10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0
8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -13 0 -15 -198 -15 -1725z M1800 6345 l0 -495 30 0 c20 0 30 5 30 15 0 8 -7 15 -15 15 -13 0
-15 60 -15 480 0 420 -2 480 -15 480 -13 0 -15 -62 -15 -495z M1800 2730 c0 -1060 2 -1200 15 -1200 13 0 15 140 15 1200 0 1060 -2
1200 -15 1200 -13 0 -15 -140 -15 -1200z M5490 3915 c0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7
-15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15
-15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8
-7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30
-15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30
-5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15
-15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15
-15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0
-30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15
-8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10
-10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15
-15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30
-5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8
-7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15
0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7
-15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0
-30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30
-15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7
-15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15
-15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15
-7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8
-7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30
-15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7
-15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15
-15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5
-30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -8 -7 -15 -15 -15 -8 0
-15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8
0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15
-15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7
-15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15
0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15
-15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15
-7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15
-8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15
-30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8
-7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30
-15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30
-5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15
-20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15
-15 -15 -8 0 -15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8
-7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15
0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7
-15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0
-15 -7 -15 -15 0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15
-15 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -10 -10
-15 -30 -15 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0
-13 28 -15 195 -15 167 0 195 2 195 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8
7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8
0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15
0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 7 15 15
15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30
5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8
7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8
0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15
0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15
30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0
15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0
10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30
15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5
30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7
15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0
15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30
15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15
15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15
7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10
10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15
20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30
15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10
15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20
0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15
0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15
30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0
30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0
8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15
8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15
15 0 10 10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7
15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0
15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0
10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30
15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7
15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10
10 15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15
8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30
15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10
15 30 15 20 0 30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8
0 15 7 15 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15
0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15
30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 10 15 30 15 20 0
30 5 30 15 0 10 10 15 30 15 20 0 30 5 30 15 0 8 7 15 15 15 8 0 15 7 15 15 0
10 10 15 30 15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10
10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10
10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8
7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10
-15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7
-15 15 -15 8 0 15 -7 15 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15
30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15
15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 20 0 30 -5 30 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -10 10 -15 30
-15 20 0 30 -5 30 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -13 30 -15 210
-15 180 0 210 2 210 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30
15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8
0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0
-15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0
-15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0
-30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0
-30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5
-30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5
-30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15
15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15
0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0
8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10
15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15
-30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15
15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8
0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0
-30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5
-30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15
15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15
0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0
8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8
-7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7
15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15
-30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15
15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8
0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0
-30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0
-30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5
-30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5
-30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5
-30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15
15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15
0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10
-10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7
15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15
-30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 10 -10 15
-30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15
15 -8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15
-8 0 -15 7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8
0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15
7 -15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7
-15 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 10 -10 15 -30 15 -20 0 -30 5
-30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15
15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15
0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 11
-12 15 -45 15 -33 0 -45 -4 -45 -15z M4770 1935 c0 -13 38 -15 285 -15 247 0 285 2 285 15 0 13 -38 15
-285 15 -247 0 -285 -2 -285 -15z M5640 1935 c0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -15 0 -8 7 -15 15
-15 8 0 15 7 15 15 0 13 40 15 300 15 260 0 300 2 300 15 0 13 -40 15 -300 15
-260 0 -300 -2 -300 -15z M4860 1065 c0 -13 22 -15 135 -15 113 0 135 2 135 15 0 13 -22 15
-135 15 -113 0 -135 -2 -135 -15z M5700 1065 c0 -13 33 -15 240 -15 207 0 240 2 240 15 0 13 -33 15
-240 15 -207 0 -240 -2 -240 -15z`;
